/** Document context for DescriptionHistory / version APIs when opened from CMS (vs task sidebar). */
export const DOCUMENT_CONTEXT_TYPE = {
  CMS: "cms",
};

export const cmsStyle = {
  BOOKMARKS_HOVER_LABEL_WIDTH: "200px",
  BOOKMARKS_PANEL_CLOSED_WIDTH: "0px",
  BOOKMARKS_PANEL_DEFAULT_SIZE: "20%",
  BOOKMARKS_PANEL_MAX_WIDTH: "300px",
};

export const cmsElementId = {
  BOOKMARKS_PIN: "cms-bookmarks-pin-btn",
  BOOKMARKS_CLOSE: "cms-bookmarks-close-btn",
  BOOKMARKS_TRIGGER_ICON: "cms-bookmarks-trigger-icon",
  BOOKMARKS_TRIGGER_LABEL: "cms-bookmarks-trigger-label",
  ACTIVE_USERS_LIST: "cms-ydoc-active-users-list",
  DOCUMENT_TREE_VIEW: "ydoc-document-tree-view",
};

/** @param {string} email */
export const getActiveUserElementId = (email) =>
  `cms-ydoc-active-user-${String(email ?? "unknown").replace(/[^a-zA-Z0-9-_]/g, "-")}`;

export const cmsPaneId = {
  BOOKMARKS: "cms-ydoc-bookmarks-pane",
  EDITOR: "cms-ydoc-editor-pane",
};

export const cmsStorageKeys = {
  BOOKMARKS_PANEL_PINNED: "cms-ydoc-bookmarks-panel-pinned",
};
